import { mapApiDataToBlogPost } from '@/lib/cms-mappers';
import { blogPostsLocales } from '@/config/locales';

import type { FBlogPostTemplateProps } from '@/components/templates/FBlogPostTemplate.vue';

const populateFields = [
  'main_image',
  'audiences',
  'main_topics',
  'other_topics',
  'content.image',
  'content.blog_post',
];

/**
 * Returns blog post data fetched from CMS (Strapi), based on its slug
 * @param slug - Blog post slug
 */
export async function useCmsBlogPost(
  slug: string
): UseCmsResponse<FBlogPostTemplateProps | null> {
  const { t } = useI18n();
  const { data, error, pending, refresh } = await useStrapi(
    'blog-posts',
    {
      localesSubset: blogPostsLocales,
      queryParams: {
        populate: populateFields.join(','),
        related_posts: 2,
      },
    },
    slug
  );

  const mappedData = computed(() => mapApiDataToBlogPost(data.value?.data));
  const i18nMappedData = computed<FBlogPostTemplateProps | null>(() => {
    return mappedData.value
      ? {
          ...mappedData.value,
          relatedPosts: mappedData.value?.relatedPosts.map(relatedPost => ({
            ...relatedPost,
            linkText: t('blog__related_posts__cards__button_text'),
          })),
        }
      : null;
  });

  return { data: i18nMappedData, error, pending, refresh };
}
